import type { FC } from 'react';

import { nameInitials } from '@iconik-io/core/src/name_initials';
import { Avatar, Text } from '@iconik-io/uad';

import styles from './segment_header_user.module.css';

type Props = {
  photoUrl?: string;
  userFullName: string;
};

export const SegmentHeaderUser: FC<Props> = ({ photoUrl, userFullName }) => {
  const [firstName, lastName] = userFullName.split(' ', 2);
  const avatarLabel = nameInitials({
    first_name: firstName,
    last_name: lastName,
  });

  return (
    <div className={styles.segment_header_user}>
      <Avatar size="s" src={photoUrl} label={avatarLabel} />
      {userFullName ? (
        <Text color="high_emphasis" elementType="span" variant="label" noWrap>
          {userFullName}
        </Text>
      ) : undefined}
    </div>
  );
};
